export const USER_ROLE = {
  ADMIN: 'ADMIN',
  STAFF: 'STAFF',
  INSTRUCTOR: 'INSTRUCTOR',
  STUDENT: 'STUDENT',
  PARENT: 'PARENT',
} as const;

export const USER_ROLE_KR = {
  [USER_ROLE.ADMIN]: '관리자',
  [USER_ROLE.STAFF]: '직원',
  [USER_ROLE.INSTRUCTOR]: '강사',
  [USER_ROLE.STUDENT]: '학생',
  [USER_ROLE.PARENT]: '부모',
} as const;

export const NAV_HEIGHT = '4rem';
export const SIDEBAR_WIDTH = {
  COLLAPSED: '5.5rem',
  EXPANDED: '16rem',
};

export const COMMON_KEYWORD_OPTIONS = [
  { label: '이름', value: 'name' },
  { label: '이메일', value: 'email' },
];
